module.exports = __webpack_public_path__ + "media/images/ivy_image-9992af57.jpg";